/* eslint-disable max-len, react/jsx-indent, react/no-danger */
import React from 'react';

import UPSCEvaluatorImage from '../../assets/images/informatics/NewIcons/UPSCEvaluator.jpg';
import UPSCMentorshipImage from '../../assets/images/informatics/NewIcons/UPSCMentorship.jpg';
import EditorsImage from '../../assets/images/informatics/NewIcons/Editors.jpg';
import UPSCContentHindiImage from '../../assets/images/informatics/NewIcons/UpscContentHindi.jpg';
import GraphicsImage from '../../assets/images/informatics/NewIcons/GRAPHICS.jpg';
import UPSCContentEnglishImage from '../../assets/images/informatics/NewIcons/UPSCContentWritersEnglish.jpg';
import UPSCFacultyEnglishImage from '../../assets/images/informatics/NewIcons/UPSCFacultyEnglish.jpg';
import UPSCFacultyHindiImage from '../../assets/images/informatics/NewIcons/UPSCFacultyHindi.jpg';
import UPSCFacultyHinglishImage from '../../assets/images/informatics/NewIcons/UPSCFacultyHinglish.jpg';
import ExamCounsellors from '../../assets/images/informatics/NewIcons/ExamCounsellor.jpg';

import styles from './policy.module.scss';

const careerData = [
  {
    formSrc: 'https://forms.gle/tmQSGEP8D5Jvta3j6',
    imgSrc: UPSCEvaluatorImage?.src,
    title: 'UPSC Evaluators',
  },
  {
    formSrc: 'https://forms.gle/Nu9vt6E5tXcd6dMo8',
    imgSrc: UPSCMentorshipImage?.src,
    title: 'UPSC Mentorship',
  },
  {
    formSrc: 'https://forms.gle/Nei4s2N2sNrFwWzV7',
    imgSrc: EditorsImage?.src,
    title: 'Editors and Scriptwriters',
  },
  {
    formSrc: 'https://forms.gle/58LnvW1eaSJEWs5M7',
    imgSrc: UPSCContentHindiImage?.src,
    title: 'UPSC Content Writers Hindi',
  },
  {
    formSrc: 'https://forms.gle/ymXuft8b5JL4ey5WA',
    imgSrc: GraphicsImage?.src,
    title: 'GRAPHICS',
  },
  {
    formSrc: 'https://forms.gle/58LnvW1eaSJEWs5M7',
    imgSrc: UPSCContentEnglishImage?.src,
    title: 'UPSC Content Writers English',
  },
  {
    formSrc: 'https://forms.gle/d5RSQx2jFJdoDdtV6',
    imgSrc: UPSCFacultyEnglishImage?.src,
    title: 'UPSC Faculty English',
  },
  {
    formSrc: 'https://forms.gle/d5RSQx2jFJdoDdtV6',
    imgSrc: UPSCFacultyHindiImage?.src,
    title: 'UPSC Faculty Hindi',
  },
  {
    formSrc: 'https://forms.gle/d5RSQx2jFJdoDdtV6',
    imgSrc: UPSCFacultyHinglishImage?.src,
    title: 'UPSC Faculty Hinglish',
  },
  {
    formSrc: 'https://forms.gle/hJczut5ygxhZG44d6',
    imgSrc: ExamCounsellors?.src,
    title: 'UPSC Exam Counsellors',
  },
];

function EachCareer({ career }) {
  return (
    <div className={styles.job_post_wrapper}>
      <div className={styles.job_post}>
        <a
          target="_blank"
          className={styles.job_post_link}
          href={career?.formSrc}
          rel="noreferrer"
        >
          <div className={styles.job_post_banner_wrapper}>
            <img className={styles.job_post_banner} src={career?.imgSrc} />
          </div>

          <h3 className={styles.job_post_title}>{career?.title}</h3>
        </a>

        <div className={styles.job_post_actions}>
          <a
            className={`${styles.btn} ${styles.btn_orange} ${styles.btn_lg}`}
            target="_blank"
            href={career?.formSrc}
            rel="noreferrer"
          >
            READ MORE
          </a>
        </div>
      </div>
    </div>
  );
}

function Career() {
  return (
    <div className={styles.container}>
      <div className={styles.careerWrapper}>
        <div className={styles.heading_main}>
          Career with Us
        </div>
        <div className={styles.midContainer_career}>
          {careerData?.map((elem) => (
            <EachCareer key={elem?.title} career={elem} />
          ))}
        </div>

      </div>

    </div>
  );
}

export default Career;
